import { CollapsibleCard, Divider, Typography } from '@atgfr8/atg-ui-tailwind';
import { customerDetailsStore } from '@store/customers/customerDetails';
import {
  StamperIcon,
  HelpCircleIcon,
  CreditCardIcon,
  CheckBoldIcon,
  CloseCircleOutlineIcon,
} from '@atgfr8/icons';
import { formatAmount } from '@utils/utils';
import { DateTime } from 'luxon';
import { Show } from 'solid-js';

import { requireHistory as classes } from '../classes';

const backgroundColor: { [key: string]: string } = {
  partiallyapproved: 'bg-[#C5E1A5]',
  approved: 'bg-[#BFDFD8]',
  prepaidapproved: 'bg-[#FFF59D]',
  denied: 'bg-[#EFCCD2]',
  pending: 'bg-[#FFE082]',
};

const getIcon = (status: string) => {
  switch (status.toLowerCase()) {
    case 'partiallyapproved':
      return <CheckBoldIcon size={36} />;
    case 'approved':
      return <StamperIcon size={36} />;
    case 'prepaidapproved':
      return <CreditCardIcon size={36} />;
    case 'denied':
      return <CloseCircleOutlineIcon size={36} />;
    case 'pending':
      return <HelpCircleIcon size={36} />;
    default:
      return null;
  }
};
const colorMap = {
  partiallyapproved: '#689F38',
  approved: '#248670',
  prepaidapproved: '#FF8F00',
  denied: '#B00020',
  inreview: '#123B50',
  pending: '#7B4F13',
};
const requestText = (status: string) => {
  switch (status.toLowerCase()) {
    case 'approved':
      return 'Request Approved By ';
    case 'denied':
      return 'Request Denied By ';
    case 'partiallyapproved':
      return 'Partial Approval By ';
    case 'prepaidapproved':
      return 'Marked Prepay By ';
    default:
      return `Request ${status}`;
  }
};

const GeneralRequestHistory = () => {
  return (
    <CollapsibleCard startTitle="Request History" class="mb-2">
      <div
        style={{
          height: 'auto',
          'max-height': '350px',
          'overflow-y': 'auto',
        }}
      >
        {[...customerDetailsStore.customer.requests].map((request) => {
          return (
            <div
              class={`${backgroundColor[request.status.toLowerCase()]} rounded-md p-2 mb-2`}
            >
              <div class="flex items-center gap-2">
                <div class="w-[95%]">
                  <div class="flex flex-col space-y-1 text-sm">
                    <div class="flex">
                      <span class="font-semibold">
                        {request.requestedByUserName}
                      </span>
                      <span class="ml-auto">
                        {DateTime.fromISO(request.requestDate).toFormat(
                          'MM/dd/yyyy',
                        )}
                      </span>
                    </div>

                    <div class="flex">
                      <span class="font-semibold">Amount Requested</span>
                      <span class="ml-auto">
                        {formatAmount(request.amount)}
                      </span>
                    </div>

                    <Show
                      when={
                        request.status.toLowerCase() === 'approved' ||
                        request.status.toLowerCase() === 'partiallyapproved'
                      }
                    >
                      <div class="flex">
                        <span>Amount Approved</span>
                        <span class="ml-auto">
                          {request.approvedAmount != null
                            ? formatAmount(request.approvedAmount)
                            : 'N/A'}
                        </span>
                      </div>
                    </Show>

                    <span>{request.details}</span>

                    <span>
                      {Boolean(request.approvedByUserName) && (
                        <Typography class={classes.amount} variant="body1">
                          {`${requestText(request.status)} `}
                          <span class={classes.usernameTypo}>
                            {request.approvedByUserName}
                          </span>
                        </Typography>
                      )}
                    </span>
                  </div>
                </div>
                <div
                  class="ml-auto"
                  style={{
                    color:
                      colorMap[
                        request.status.toLowerCase() as keyof typeof colorMap
                      ] || '#000000',
                  }}
                >
                  {getIcon(request.status.toLowerCase())}
                </div>
              </div>
              <Show when={request.comment}>
                <Divider />
                <span class="text-sm">{request.comment}</span>
              </Show>
            </div>
          );
        })}
      </div>
    </CollapsibleCard>
  );
};

export default GeneralRequestHistory;
